import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSetAuth, useLoginWithPassword } from '../hooks/useAdminAuth';
import { AuthContext } from '../App';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSnowflake } from '@fortawesome/free-solid-svg-icons';

const snowflakeIcon = <FontAwesomeIcon icon={faSnowflake} />

const emailValidation = (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

export default function SuperAdminLogin() {
  const auth = useLoginWithPassword();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [token, setToken] = useState(null);
  const [valid, setValid] = useState(true);
  const onChange = e => setEmail(e.target.value);
  const validate = () => emailValidation.test(email);

  useSetAuth(token);

  useEffect(() => {
    if (token) {
      navigate('/admin');
    }
  }, [token]);

  const reValidate = e => {
    if (!valid && validate()) {
      setValid(true);
    }
    if (e.key === 'Enter') {
      auth.mutate({ email: email });
    }
  }

  const login = () => {
    auth.mutateAsync({
      email: email,
      password: password
    })
    .then(res => setToken(res));
  }

  return <div className="hero is-medium">
    <div className="hero-body">
      <div className="container has-text-centered">
        <span className="icon is-large">
          <i className="fa fa-2x fa-car"></i>&nbsp;
          <i className="fa fa-3x fa-car"></i>&nbsp;
          <i className="fa fa-2x fa-car"></i>
        </span>
        <h1 className="title">
            <span className="icon">
              {/* Placeholder till we can find the SVG! */}
              <i>{snowflakeIcon}</i>
            </span>
            <span> Waitsfield Ski & Skate Sale </span>
            <span className="icon">
              <i>{snowflakeIcon}</i>
            </span>
        </h1>
        <h1 className="subtitle">Admin Login</h1>
        <div className="columns">
          <div className="column is-one-third"></div>
          <div className="column is-one-third">
            {!valid && <div className="notification is-danger">Invalid email address</div>}
            <div className="field">
              <div className="control is-expanded">
                <input type="email"
                  autoFocus
                  name="email"
                  placeholder="Email"
                  className="input"
                  value={email}
                  onKeyPress={reValidate}
                  onBlur={onChange}
                  onChange={onChange} />
              </div>
            </div>

            <div className="field">
              <div className="control is-expanded">
                <input type="password"
                  autoFocus
                  name="password"
                  placeholder="Password"
                  className="input"
                  value={password}
                  onBlur={e => setPassword(e.target.value)}
                  onChange={e => setPassword(e.target.value)} />
              </div>
            </div>

            <button className="button is-fullwidth is-link" onClick={login} disabled={auth.isLoading}>Login</button>
          </div>
          <div className="column is-on-third"></div>
        </div>
        <div className="has-text-centered">
          <small>© 2024 waitsfieldpta.org</small>
        </div>
      </div>
    </div>
  </div>
}
